module.exports = __webpack_public_path__ + "img/8.793f938a.webp";